import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { BodyTextLarge } from 'Packages/FacetDesign/Components';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';

const FromAccountDetails = () => {
  const isMobile = useMobileLayout();
  const maxWidth = isMobile ? '100%' : '49%';
  const alignment = isMobile ? 'center' : undefined;
  return (
    <FDStack direction={'column'} width={maxWidth} justifyContent={'center'} alignItems={alignment}>
      <BodyTextLarge align={alignment} value={<strong>Account rolling over:</strong>} />
      <MetaField attr="originAccountName" />
      <MetaField attr="originAccountNumber" />
    </FDStack>
  );
};

FromAccountDetails.defaultProps = {
};

FromAccountDetails.propTypes = {
};

export default FromAccountDetails;
